// //  import { useEffect, useState } from 'react';
// // import States from '../../components/States';
// // import { Input, Label, Selectbox } from '../../css/Shared'
// // import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
// // import { useParams } from 'react-router-dom';
// // import  Collapse  from '../../util/Collapse';
// // import { useAppContext } from '../../context/AppContext';
// // import axios from 'axios';
// // import { FaCaretDown } from "react-icons/fa6";
// // import { FaFileZipper } from "react-icons/fa6";
// // import api from '../../components/Api';

// //  const JobsPanel = () => {

// //  const [formData, setFormData] = useState()
// //   const [showMachineablePopup, setShowMachineablePopup] = useState(false);

// //  const [info, setInfo] = useState({})

// // const {user, axiUrl} = useAppContext()


// //  const param = useParams()

// // useEffect(() => {

// // const getjobinfo = async() => {
// // await api.post(`/jobs/getjob`,{id:param?.id})
// // .then(res => {
// //   console.log(res.data)
// //   setInfo(res.data.message)
// // })
// // }
// // getjobinfo()

// // },[param])

// //   const basePromotions = [
// //     'Integrated Technology (IT)',
// //     'Tactile Sensory Interactive (SS)',
// //     'Advertising with First Class',
// //     'Continuous Contact',
// //     'Catalog Promotion',
// //   ];

// //   const addOns = ['Informed Delivery', 'Sustainability', 'Both'];

// //   const handleDownload = (e, companyName, jobId, jobNum) => {
// //   e.stopPropagation();
// //   const encodedCompanyName = encodeURIComponent(companyName);
// //   const downloadUrl = `https://lightningpresort.com/uploads/files/${jobId}_${jobNum}.zip`;
// //   const link = document.createElement('a');
// //   link.href = downloadUrl;
// //   link.setAttribute('download', `${jobId}.zip`);
// //   document.body.appendChild(link);
// //   link.click();
// //   document.body.removeChild(link);
// // };

// //   console.log(info)

// //       return (
// //         <div  className="w-full mx-auto p-6 bg-gray-50 font-sans ">
// //           <h1 className="text-2xl font-bold text-center mb-6">Job Ticket</h1>
// // <div className='tabs-container'>
// // <Tabs >
// //     <TabList className='react-tabs__tab-list'>
// //       <Tab className='react-tabs__tab'>Mailing Info</Tab>
// //       <Tab className='react-tabs__tab'>Files / PaperWork</Tab>
     
// //     </TabList>
// //      <TabPanel className='react-tabs__tab-panel'>
// //           {/* Part 1: Permit Holder Information */}
// //             <label className="block text-lg font-large text-gray-700 font-bold pb-5">{info?.jobDescription}</label>
// //           <div className="mb-6 p-4 pt-0 border border-gray-400 rounded bg-white">
           
// //             <h2 className="text-lg font-semibold mb-4">Mailer Information</h2>
// //  <div className="grid grid-cols-3 gap-8"> <div>
// //   <label className="block text-md font-medium text-gray-700">Permit Holder Name</label>
// //             <Collapse title={  
// //                 <div className='flex'> 
// //                   {info?.permitHolder?.companyName} &nbsp;<FaCaretDown className='rel mt-[5px]'/>
// //                 </div>}>
          
// //                 <div>{info?.permitHolder?.address} </div>
// //           <div>{info?.permitHolder?.address2} </div>
// // <div className="flex gap-4">
// //    <div>{info?.permitHolder?.city} </div>
// //                  <div > {info?.permitHolder?.state}</div>
// //                  <div>{info?.permitHolder?.zip} </div>

// // </div>
// //   <div className="flex items-center gap-2 mt-2">
// //               <div className='flex-1 mt-1'>
// //                 <Label >PermitTpye</Label>
// //   <Selectbox className="inline-block" value={info?.permitHolder?.permitType} disabled>
// //     <option value=''>Select</option>
// //     <option value='Indicia'>Indicia</option>
// //      <option value='Stamp'>Stamp</option>
// //       <option value='Meter'>Meter</option>
// //   </Selectbox>
// //   </div>
// //   <div  className='flex-1'>
// //      <Label >Permit Number</Label>
// //     <Input value={info?.permitHolder?.permitNumber}
// //                   type="text"
// //                   className="mt-1 block w-full border-gray-300 rounded-md shadow-sm p-2"
// //                    disabled/></div>
// // </div>
// //    <div className="flex items-center gap-2 mt-2">
// //               <div className='flex-1'>
// //                   <Label mb="4px">Net Due Permit #</Label>
// //  <Input value={info?.permitHolder?.dueNetNumber}
// //                   type="text"
// //                   className="mt-1 block w-full border-gray-300 rounded-md shadow-sm p-2"
// //                     disabled />
// //   </div>
// //   <div  className='flex-1'>
// //        <Label mb="4px">Account # (EPS or Other)</Label>
// //        <Input value={info?.permitHolder?.accountNumber}
// //                   type="text"
// //                   className="mt-1 block w-full border-gray-300 rounded-md shadow-sm p-2"
// //                    disabled /></div>
// // </div>
           
// // <div className='mt-2'>
// //   <Label>BMEU where permit is registered</Label>
// //   <Selectbox  value={info?.permitHolder?.bmeu} disabled>
// //    <option value={info?.permitHolder?.bmeu}>{info?.permitHolder?.bmeu}</option>
// //   </Selectbox >
// // </div>
// //             </Collapse>
// //              </div>

// // <div>
// //                 <label className="block text-md font-medium text-gray-700">Mail Owner Name</label>
// // <Collapse title={ <div className='flex'> 
// //                   {info?.mailOwner?.companyName} &nbsp;<FaCaretDown className='rel mt-[5px]'/>
// //                 </div>}>

// //                 <div>{info?.mailOwner?.address} </div>
// //           <div>{info?.mailOwner?.address2} </div>
// // <div className="flex gap-4">
// //    <div>{info?.mailOwner?.city} </div>
// //                  <div > {info?.mailOwner?.state}</div>
// //                  <div>{info?.mailOwner?.zip} </div>

// // </div>
// //             <div className="flex items-center gap-2 mt-2">
// //               <div className='flex-1 mt-2'>
// //                <Label mb="4px">Mail Owner CRID</Label>
// //                  <Input
// //                  value={info?.mailOwner?.crid}
// //                   type="text"
// //                   className="mt-1 block w-full border-gray-300 rounded-md shadow-sm p-2"
// //                   disabled/>
// //   </div>
// //   <div  className='flex-1'>
// //      <Label mb="4px">Mail Owner MID</Label>
// //     <Input
// //     value={info?.mailOwner?.mid}
// //                   type="text"
// //                   className="mt-1 block w-full border-gray-300 rounded-md shadow-sm p-2"
// //                   disabled/></div>
// // </div>

// //    <div className="flex items-center gap-2 mt-2">
// //               <div className='flex-1'>
// //                   <Label mb="4px">Nonprofit Authorization Number</Label>
// //  <Input 
// //  value={info?.mailOwner?.nonprofitnumber}
// //                   type="text"
// //                   className="mt-1 block w-full border-gray-300 rounded-md shadow-sm p-2"
// //                   disabled/>
// //   </div>
// //   <div  className='flex-1'>
// //        <Label mb="4px">Mail Anywhere Account Number</Label>
// //        <Input
// //        value={info?.mailOwner?.anywhere}
// //                   type="text"
// //                   className="mt-1 block w-full border-gray-300 rounded-md shadow-sm p-2"
// //                   disabled/></div>
// // </div> 
// // </Collapse>
// //               </div>
// //   <div>
// //                 <label className="block text-md font-medium text-gray-700">Mail Provider Name</label>
// //               <Collapse title={<div className='flex'> 
// //                   {info?.mailProvider?.providerName} &nbsp;<FaCaretDown className='rel mt-[5px]'/>
// //                 </div>} >
// //                <div>{info?.mailProvider?.address} </div>
// //           <div>{info?.mailProvider?.address2} </div>
// // <div className="flex gap-4">
// //    <div>{info?.mailProvider?.city} </div>
// //                  <div > {info?.mailProvider?.state}</div>
// //                  <div>{info?.mailProvider?.zip} </div>

// // </div>
              
              
// //              <div className="flex items-center gap-2 mt-2">
// //               <div className='flex-1 mt-2'>
// //                <Label mb="4px">Mail Agent CRID</Label>
// //                  <Input
// //                   value={info?.mailProvider?.crid}
// //                   type="text"
// //                   className="mt-1 block w-full border-gray-300 rounded-md shadow-sm p-2"
// //                   disabled/>
// //   </div>
// //   <div  className='flex-1'>
// //      <Label mb="4px">Mail Agent MID</Label>
// //     <Input
// //      value={info?.mailProvider?.mid}
// //                   type="text"
// //                   className="mt-1 block w-full border-gray-300 rounded-md shadow-sm p-2"
// //                   disabled/></div>
// // </div>
// //                      <div className="flex items-center gap-2 mt-2">
// //               <div className='flex-1 mt-2'>
// //                <Label mb="4px">Represenative Name (First Last)</Label>
// //                  <Input
// //                  value={info?.mailProvider?.repname}
// //                   type="text"
// //                   className="mt-1 block w-full border-gray-300 rounded-md shadow-sm p-2"
// //                   disabled/>
// //   </div>
// //   <div  className='flex-[.5]'>
// //      <Label mb="4px">Phone Number</Label>
// //     <Input
// //     value={info?.mailProvider?.repphone}
// //                   type="text"
// //                   className="mt-1 block w-full border-gray-300 rounded-md shadow-sm p-2"
// //                  disabled/></div>
// // </div>
// //             <div className="flex items-center gap-2 mt-2">
// //   <div  className='flex-1'>
// //        <Label mb="4px">Email</Label>
// //        <Input
// //         value={info?.mailProvider?.repemail}
// //                   type="text"
// //                   className="mt-1 block w-full border-gray-300 rounded-md shadow-sm p-2"
// //                   disabled/></div>
// // </div> 
// //  <div className='flex'>
// //       <div className="pl-[12px] flex-1">
// //   <label className="inline-flex items-center mt-2">
// //     <input
// //       type="checkbox"
// //       className="mr-2 appearance-none w-4 h-4 border-2 border-gray-300 rounded bg-gray-100 checked:bg-blue-600 disabled:checked:bg-blue-600 disabled:opacity-75"
// //       name="einduction"
// //       checked={info?.mailProvider?.einduction}
// //       disabled
// //     />
// //     <span className="text-sm text-gray-700">eInduction</span>
// //   </label>
// // </div>
// //               <div className='pl-[12px] flex-1'>
// //                 <label className="inline-flex items-center mt-2">
// //                <input
// //       type="checkbox"
// //       className="mr-2 appearance-none w-4 h-4 border-2 border-gray-300 rounded bg-gray-100 checked:bg-blue-600 disabled:checked:bg-blue-600 disabled:opacity-75"
// //       name="einduction"
// //       checked={info?.mailProvider?.seamless}
// //       disabled
// //     />
// //                   <span className="text-sm text-gray-700"> Seamless Acceptance</span>
// //                 </label>
// //               </div>
// //    </div>
// //               </Collapse>
// //   </div>
// //  </div>
// // </div>



// //           {/* Part 2: Mailing Details */}
// //                   <div className="mb-6 p-4 border border-gray-400 rounded bg-white">
// //             <h2 className="text-lg font-semibold mb-4">Mailing Details</h2>
// //             <div className="grid grid-cols-3 gap-8">

// //               <div>
// //                 <label className="block text-sm font-medium text-gray-700">Product</label>
// //  <Collapse title={<div className='flex'> 
// //                   {info?.product?.name} &nbsp;<FaCaretDown className='rel mt-[5px]'/>
// //                 </div>} >
// //                   <div className='flex gap-8 mt-4'>
// //                   <div className='flex-1'><Label>Height</Label>  <Input
// //                   value={info?.product?.width}
// //                   type="text"
// //                   className="mt-1 block w-full border-gray-300 rounded-md shadow-sm p-2"
// //                   disabled/></div>
// //                    <div className='flex-1'><Label>Length</Label>  <Input
// //                   value={info?.product?.length}
// //                   type="text"
// //                   className="mt-1 block w-full border-gray-300 rounded-md shadow-sm p-2"
// //                   disabled/></div>
// //                     <div className='flex-1'><Label>Thickness</Label>  <Input
// //                   value={info?.product?.thickness}
// //                   type="text"
// //                   className="mt-1 block w-full border-gray-300 rounded-md shadow-sm p-2"
// //                   disabled/></div>
                    
// //                 </div>
                
// //                   <div className='flex gap-8 mt-4'>
// //                    <div className='flex-1'><Label>Weight</Label>  <Input
// //                    value={info?.product?.weight}
// //                   type="text"
// //                   className="mt-1 block w-full border-gray-300 rounded-md shadow-sm p-2"
// //                   disabled/></div>
// //                     <div className='flex-[.4]'><Label>By Volume</Label>  <Selectbox value={info?.product?.weightUnit} disabled>
// //                       <option value={info?.product?.weightUnit}>{info?.product?.weightUnit}</option>
// //                       </Selectbox></div>
                    
// //                 </div>
                
                
// //                 </Collapse>



               
// //         <div className='pl-[12px] flex-1'>
// //                 <label className="inline-flex items-center mt-2">
// //                  <input
// //       type="checkbox"
// //       className="mr-2 appearance-none w-4 h-4 border-2 border-gray-300 rounded bg-gray-100 checked:bg-blue-600 disabled:checked:bg-blue-600 disabled:opacity-75"
// //       name="einduction"
// //       checked={info?.machinable}
// //       disabled
// //     />
// //                    <Label className="mt-2" htmlFor="machineable">Machineable</Label>
// //                 </label>
// //               </div>
// //               <div className='pl-[12px] flex-1'>
// //                 <label className="inline-flex items-center mt-2">
// //                  <input
// //       type="checkbox"
// //       className="mr-2 appearance-none w-4 h-4 border-2 border-gray-300 rounded bg-gray-100 checked:bg-blue-600 disabled:checked:bg-blue-600 disabled:opacity-75"
// //       name="einduction"
// //       checked={info?.dropship === 'true' ? true : false}
// //       disabled
// //     />
// //                    <Label className="mt-2" htmlFor="machineable">Drop Shipping</Label>
// //                 </label>
// //                 {info?.dropship === 'true' && (
// //                   <Input
// //                   value={info?.dropshipname}
// //                   type="text"
// //                   className="mt-1 block w-full border-gray-300 rounded-md shadow-sm p-2"
// //                   disabled/>
// //                 )

// //                 }
// //               </div>
  
// // <div className='mt-4'>
// //   <div className='text-md'>Promotions:{info?.basepromotions > '' ? '  Yes' : '  No'}</div>
// //   {
// //     info?.basepromotions > '' ? <> <div className='flex-1'><Label>Base Promotion</Label> <Selectbox value={info?.basepromotions}>
// //              <option value={info?.basepromotions} disabled>
// //               {info?.basepromotions}
// //              </option>
// //            </Selectbox></div>
// //                    <div className=''><Label>Add-Ons</Label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{info?.addon1}<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{info?.addon2}  </div> </> : null
// //   }

// //   </div>
// //  </div>




// //                 <div>
// //                  <div>
// //                 <Label className="block text-sm font-medium text-gray-700 ">Mail Class</Label>
// //             <Input
// //             value={info?.mailClass}
// //                   type="text"
// //                   className="mt-1 block w-full border-gray-300 rounded-md shadow-sm p-2"
// //                   disabled/>
// //                 </div>
// //                  <div className='mt-4'>
// //              <Label className="block text-sm font-medium text-gray-700">Mail Date</Label>
// //                 <Input
// //                  value={info?.mailDate }
// //                   type="text"
// //                   className="mt-1 block w-full border-gray-300 rounded-md shadow-sm p-2"
// //                   disabled/>
// //                 </div>
// //                    <div className='mt-4'>
// //              <Label>Pay Method</Label>
// //                 <Selectbox value={info?.permitHolder?.permitType} disabled>
// //                   <option value={info?.permitHolder?.permitType} >
// //                    {info?.permitHolder?.permitType}
// //                   </option>
// //                 </Selectbox>
// //                 </div>
// //   <div className='mt-4'>
// //              <Label>Post Office of Entry</Label>
// //                 <Selectbox value={info?.postOfficeEntry} disabled>
// //                  <option value={info?.postOfficeEntry} >{info?.postOfficeEntry}</option>
// //                 </Selectbox>
// //                 </div>
// //     <div className=' flex-1'>
// //                 <Label className="mt-2" htmlFor="">Job ID</Label>
// //                   <Input 
// //                   value={info?.uspsJobId}
// //                     type="text" 
// //                     className="mr-2" 
// //                     name="seamless" 
// //                     disabled
// //                   />
                   
              
// //               </div>
// //               </div>
              
// //    <div>
// //                  <div>Advanced Options</div>
// //                 <div className='pl-[12px] flex-1'>
// //                 <label className="inline-flex items-center mt-2">
// //                 <input
// //       type="checkbox"
// //       className="mr-2 mt-2 appearance-none w-4 h-4 border-2 border-gray-300 rounded bg-gray-100 checked:bg-blue-600 disabled:checked:bg-blue-600 disabled:opacity-75"
// //       name="einduction"
// //       checked={info?.dropship ? true : false}
// //       disabled
// //     />
// //                    <Label className="mt-2" htmlFor="">No 1' Trays (MM or EMM)</Label>
// //                 </label>
// //               </div>

// //                <div className='pl-[12px] flex-1'>
// //                 <label className="inline-flex items-center mt-2">
// //                  <input
// //       type="checkbox"
// //       className="mr-2 mt-1 appearance-none w-4 h-4 border-2 border-gray-300 rounded bg-gray-100 checked:bg-blue-600 disabled:checked:bg-blue-600 disabled:opacity-75"
// //       name="einduction"
// //       checked={info?.growthIncentive ? true : false}
// //       disabled
// //     />
// //                    <Label className="mt-2" htmlFor="">Growth Incentive Credit Redemption</Label>
// //                 </label>
// //               </div>

// //                <div className='pl-[12px] flex-1'>
// //                 <label className="inline-flex items-center mt-2">
// //                       <input
// //       type="checkbox"
// //       className="mr-2 mt-1 appearance-none w-4 h-4 border-2 border-gray-300 rounded bg-gray-100 checked:bg-blue-600 disabled:checked:bg-blue-600 disabled:opacity-75"
// //       name="einduction"
// //       checked={info?.ballotbox ? true : false}
// //       disabled
// //     />
// //                    <Label className="mt-2" htmlFor="">Ballot Mail</Label>
// //                 </label>
// //               </div>
// //               <div className='pl-[12px] flex-1'>
// //                 <label className="inline-flex items-center mt-2">
// //                  <input
// //       type="checkbox"
// //       className="mr-2 mt-1 appearance-none w-4 h-4 border-2 border-gray-300 rounded bg-gray-100 checked:bg-blue-600 disabled:checked:bg-blue-600 disabled:opacity-75"
// //       name="einduction"
// //       checked={info?.political ? true : false}
// //       disabled
// //     />
// //                    <Label className="mt-2" htmlFor="">Political Mail</Label>
// //                 </label>
// //               </div>
// //                      {/* <div className='pl-[12px] flex-1'>
// //                 <Label className="inline-flex items-center mt-2">
// //                   Small Pallets </Label>
// //                    <Selectbox value={formData?.paymentMethod} required>
// //                  <option value="" Selectboxed disabled>
// //           Selectbox Option
// //         </option>
// //         <option value="none">None</option>
// //         <option value="letters">
// //           Letters & Postcards (Min 6' per Pallet)
// //         </option>
// //         <option value="flats">
// //           Flats (Min 100 lbs, Max 800 lbs)
// //         </option>
// //                 </Selectbox>
// //   //             </div> 
// //   // <div className='pl-[12px] flex-1'>
// //   //               <Label className="inline-flex items-center mt-2">
// //   //                 Tall Pallets </Label>
// //   //                  <Selectbox value={formData?.paymentMethod} required>
// //   //                 <option value="" Selectboxed disabled>
// //   //         Selectbox Option
// //   //       </option>
// //   //       <option value="none">None</option>
// //   //       <option value="emm">EMM (Max 96")</option>
// //   //       <option value="mm">MM (Max 120")</option>
// //   //               </Selectbox>
// //   //             </div>*/}


// //               </div>

// // <div>
  

// // </div>
// //   <div>
                
// //               </div>
           
// //             </div>
// //           </div>

// //           {/* Part 3: Summary */}
// //           <div className="mb-6 p-4 border border-gray-300 rounded bg-white">
// //             <h2 className="text-lg font-semibold mb-4">Summary</h2>
// //             <div className="grid grid-cols-2 gap-4">
// //               <div>
// //                 <label className="block text-sm font-medium text-gray-700">Total Weight (lbs)</label>
// //                 <Input
// //                   type="number"
// //                   step="0.01"
// //                   className="mt-1 block w-full border-gray-300 rounded-md shadow-sm p-2"
// //                   placeholder="Enter total weight"
// //                 />
// //               </div>
// //               <div>
// //                 <label className="block text-sm font-medium text-gray-700">Postage Amount ($)</label>
// //                 <Input
// //                   type="number"
// //                   step="0.01"
// //                   className="mt-1 block w-full border-gray-300 rounded-md shadow-sm p-2"
// //                   placeholder="Enter postage amount"
// //                 />
// //               </div>
// //               <div className="col-span-2">
// //                 <label className="block text-sm font-medium text-gray-700">Additional Notes</label>
// //                 <textarea
// //                   className="mt-1 block w-full border-gray-300 rounded-md shadow-sm p-2"
// //                   rows="4"
// //                   placeholder="Enter any additional notes"
// //                 ></textarea>
// //               </div>
// //             </div>

// //           </div>

// //           {/* Submit Button */}
// //           <div className="text-right">
            
// //           </div>
// //           </TabPanel>
// // <TabPanel className='react-tabs__tab-panel'>
// //   <div className='flex items-center cursor-pointer'  onClick={(e) => handleDownload(e, user?.company.name, info.jobId, info.jobNum)}>
// //     <FaFileZipper
// //       size={24}
     
// //       className='inline-block'
// //     />
// //     <span className='ml-2'>
// //      -  {info?.jobId}_{info.jobNum}.zip
// //     </span>
// //   </div>
// // </TabPanel>
             
// //           </Tabs>
// //           </div>
// //         </div>
// //       );
// //     };
// //  export default JobsPanel





// import { useEffect, useState } from "react";
// import { Input, Label, Selectbox } from "../../css/Shared";
// import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
// import { useParams } from "react-router-dom";
// import Collapse from "../../util/Collapse";
// import { useAppContext } from "../../context/AppContext";
// import { FaCaretDown, FaFileZipper } from "react-icons/fa6";
// import api from "../../components/Api";

// const labelClass = "block text-sm font-semibold text-gray-700 mb-1";
// const inputClass =
//   "w-full border border-gray-300 rounded-md p-2 text-sm bg-gray-50";
// const sectionTitle =
//   "text-lg font-semibold text-gray-800 mb-4 border-b pb-2";

// const FormField = ({ label, value }) => (
//   <div>
//     <label className={labelClass}>{label}</label>
//     <Input value={value || ""} className={inputClass} disabled />
//   </div>
// );

// const FormSelect = ({ label, value }) => (
//   <div>
//     <label className={labelClass}>{label}</label>
//     <Selectbox value={value || ""} className={inputClass} disabled>
//       <option>{value}</option>
//     </Selectbox>
//   </div>
// );

// const CheckboxField = ({ label, checked }) => (
//   <label className="flex items-center gap-2 text-sm text-gray-700 mt-2">
//     <input
//       type="checkbox"
//       checked={checked}
//       disabled
//       className="w-4 h-4 border-gray-300 rounded"
//     />
//     {label}
//   </label>
// );

// const JobsPanel = () => {
//   const [info, setInfo] = useState({});
//   const { user } = useAppContext();
//   const param = useParams();

//   useEffect(() => {
//     const getjobinfo = async () => {
//       const res = await api.post(`/jobs/getjob`, { id: param?.id });
//       setInfo(res.data.message);
//     };

//     getjobinfo();
//   }, [param]);

//   const handleDownload = (e, companyName, jobId, jobNum) => {
//     e.stopPropagation();
//     const downloadUrl = `https://lightningpresort.com/uploads/files/${jobId}_${jobNum}.zip`;

//     const link = document.createElement("a");
//     link.href = downloadUrl;
//     link.setAttribute("download", `${jobId}.zip`);
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   };

//   return (
//     <div className="max-w-7xl mx-auto p-8 bg-gray-100 font-sans">
//       <h1 className="text-2xl font-bold text-gray-800 text-center mb-8">
//         Job Ticket
//       </h1>

//       <Tabs>
//         <TabList className="react-tabs__tab-list">
//           <Tab>Mailing Info</Tab>
//           <Tab>Files / PaperWork</Tab>
//         </TabList>

//         {/* MAILING INFO */}
//         <TabPanel>
//           <label className="block text-xl font-semibold text-gray-800 mb-6">
//             {info?.jobDescription}
//           </label>

//           {/* MAILER INFORMATION */}
//           <div className="mb-8 p-6 border border-gray-200 rounded-lg bg-white shadow-sm">
//             <h2 className={sectionTitle}>Mailer Information</h2>

//             <div className="grid grid-cols-3 gap-6">
//               <Collapse
//                 title={
//                   <div className="flex items-center justify-between text-sm font-semibold">
//                     {info?.permitHolder?.companyName}
//                     <FaCaretDown />
//                   </div>
//                 }
//               >
//                 <FormField
//                   label="Address"
//                   value={info?.permitHolder?.address}
//                 />
//                 <FormField
//                   label="Address 2"
//                   value={info?.permitHolder?.address2}
//                 />
//                 <FormField
//                   label="City"
//                   value={info?.permitHolder?.city}
//                 />
//                 <FormField
//                   label="State"
//                   value={info?.permitHolder?.state}
//                 />
//                 <FormField label="Zip" value={info?.permitHolder?.zip} />
//                 <FormSelect
//                   label="Permit Type"
//                   value={info?.permitHolder?.permitType}
//                 />
//                 <FormField
//                   label="Permit Number"
//                   value={info?.permitHolder?.permitNumber}
//                 />
//                 <FormField
//                   label="Net Due Permit #"
//                   value={info?.permitHolder?.dueNetNumber}
//                 />
//                 <FormField
//                   label="Account #"
//                   value={info?.permitHolder?.accountNumber}
//                 />
//                 <FormSelect label="BMEU" value={info?.permitHolder?.bmeu} />
//               </Collapse>

//               <Collapse
//                 title={
//                   <div className="flex items-center justify-between text-sm font-semibold">
//                     {info?.mailOwner?.companyName}
//                     <FaCaretDown />
//                   </div>
//                 }
//               >
//                 <FormField label="Address" value={info?.mailOwner?.address} />
//                 <FormField label="City" value={info?.mailOwner?.city} />
//                 <FormField label="State" value={info?.mailOwner?.state} />
//                 <FormField label="Zip" value={info?.mailOwner?.zip} />
//                 <FormField label="CRID" value={info?.mailOwner?.crid} />
//                 <FormField label="MID" value={info?.mailOwner?.mid} />
//                 <FormField
//                   label="Nonprofit #"
//                   value={info?.mailOwner?.nonprofitnumber}
//                 />
//                 <FormField
//                   label="Mail Anywhere #"
//                   value={info?.mailOwner?.anywhere}
//                 />
//               </Collapse>

//               <Collapse
//                 title={
//                   <div className="flex items-center justify-between text-sm font-semibold">
//                     {info?.mailProvider?.providerName}
//                     <FaCaretDown />
//                   </div>
//                 }
//               >
//                 <FormField
//                   label="Address"
//                   value={info?.mailProvider?.address}
//                 />
//                 <FormField label="City" value={info?.mailProvider?.city} />
//                 <FormField label="State" value={info?.mailProvider?.state} />
//                 <FormField label="Zip" value={info?.mailProvider?.zip} />
//                 <FormField label="CRID" value={info?.mailProvider?.crid} />
//                 <FormField label="MID" value={info?.mailProvider?.mid} />
//                 <FormField
//                   label="Representative"
//                   value={info?.mailProvider?.repname}
//                 />
//                 <FormField
//                   label="Phone"
//                   value={info?.mailProvider?.repphone}
//                 />
//                 <FormField
//                   label="Email"
//                   value={info?.mailProvider?.repemail}
//                 />

//                 <CheckboxField
//                   label="eInduction"
//                   checked={info?.mailProvider?.einduction}
//                 />

//                 <CheckboxField
//                   label="Seamless Acceptance"
//                   checked={info?.mailProvider?.seamless}
//                 />
//               </Collapse>
//             </div>
//           </div>

//           {/* MAIL DETAILS */}
//           <div className="mb-8 p-6 border border-gray-200 rounded-lg bg-white shadow-sm">
//             <h2 className={sectionTitle}>Mailing Details</h2>

//             <div className="grid grid-cols-3 gap-6">
//               <FormField label="Product" value={info?.product?.name} />
//               <FormField label="Mail Class" value={info?.mailClass} />
//               <FormField label="Mail Date" value={info?.mailDate} />

//               <FormField
//                 label="Post Office Entry"
//                 value={info?.postOfficeEntry}
//               />

//               <FormField label="USPS Job ID" value={info?.uspsJobId} />

//               <CheckboxField
//                 label="Machineable"
//                 checked={info?.machinable}
//               />

//               <CheckboxField
//                 label="Drop Shipping"
//                 checked={info?.dropship === "true"}
//               />

//               <CheckboxField
//                 label="Growth Incentive"
//                 checked={info?.growthIncentive}
//               />

//               <CheckboxField
//                 label="Ballot Mail"
//                 checked={info?.ballotbox}
//               />

//               <CheckboxField
//                 label="Political Mail"
//                 checked={info?.political}
//               />
//             </div>
//           </div>

//           {/* SUMMARY */}
//           <div className="mb-8 p-6 border border-gray-200 rounded-lg bg-white shadow-sm">
//             <h2 className={sectionTitle}>Summary</h2>

//             <div className="grid grid-cols-2 gap-6">
//               <FormField label="Total Weight" value="" />
//               <FormField label="Postage Amount" value="" />
//             </div>

//             <div className="mt-6">
//               <label className={labelClass}>Additional Notes</label>
//               <textarea
//                 className="w-full border border-gray-300 rounded-md p-3 text-sm"
//                 rows="4"
//               />
//             </div>
//           </div>
//         </TabPanel>

//         {/* FILES TAB */}
//         <TabPanel>
//           <div
//             className="flex items-center gap-3 p-4 border rounded-md bg-white hover:bg-gray-50 cursor-pointer w-fit"
//             onClick={(e) =>
//               handleDownload(e, user?.company.name, info.jobId, info.jobNum)
//             }
//           >
//             <FaFileZipper size={22} className="text-blue-600" />

//             <span className="text-sm font-medium text-gray-700">
//               {info?.jobId}_{info?.jobNum}.zip
//             </span>
//           </div>
//         </TabPanel>
//       </Tabs>
//     </div>
//   );
// };

// export default JobsPanel;



import { useEffect, useState } from "react";
import { Input, Label, Selectbox } from "../../css/Shared";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { useParams } from "react-router-dom";
import Collapse from "../../util/Collapse";
import { useAppContext } from "../../context/AppContext";
import { FaCaretDown, FaFileZipper } from "react-icons/fa6";
import api from "../../components/Api";

const labelClass = "block text-sm font-semibold text-gray-700 mb-1";
const inputClass =
  "w-full border border-gray-300 rounded-md p-2 text-sm bg-gray-50";
const sectionTitle =
  "text-lg font-semibold text-gray-800 mb-4 border-b pb-2";

const FormField = ({ label, value }) => (
  <div className="mb-3">
    <label className={labelClass}>{label}</label>
    <Input value={value || ""} className={inputClass} disabled />
  </div>
);

const FormSelect = ({ label, value }) => (
  <div className="mb-3">
    <label className={labelClass}>{label}</label>
    <Selectbox value={value || ""} className={inputClass} disabled>
      <option>{value}</option>
    </Selectbox>
  </div>
);

const CheckboxField = ({ label, checked }) => (
  <label className="flex items-center gap-2 text-sm text-gray-700 mt-2">
    <input
      type="checkbox"
      checked={checked}
      disabled
      className="w-4 h-4 border-gray-300 rounded"
    />
    {label}
  </label>
);

const JobsPanel = () => {
  const [info, setInfo] = useState({});
  const { user } = useAppContext();
  const param = useParams();

  useEffect(() => {
    const getjobinfo = async () => {
      const res = await api.post(`/jobs/getjob`, { id: param?.id });
      setInfo(res.data.message);
    };
    getjobinfo();
  }, [param]);

  const handleDownload = (e, companyName, jobId, jobNum) => {
    e.stopPropagation();
    const downloadUrl = `https://lightningpresort.com/uploads/files/${jobId}_${jobNum}.zip`;
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.setAttribute("download", `${jobId}.zip`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="max-w-7xl mx-auto p-8 bg-gray-100 font-sans">
      <h1 className="text-2xl font-bold text-gray-800 text-center mb-8">
        Job Ticket
      </h1>

      <Tabs>
        <TabList className="react-tabs__tab-list mb-4">
          <Tab>Mailing Info</Tab>
          <Tab>Files / PaperWork</Tab>
        </TabList>

        {/* MAILING INFO */}
        <TabPanel>
          <label className="block text-xl font-semibold text-gray-800 mb-6">
            {info?.jobDescription}
          </label>

          {/* MAILER INFORMATION */}
          {/* MAILER INFORMATION */}
<div className="mb-6 p-4 border border-gray-200 rounded-lg bg-white shadow-sm">
  <h2 className="text-lg font-semibold text-gray-800 mb-4">Mailer Information</h2>

  <div className="grid lg:grid-cols-3 gap-4">

    {/* Permit Holder */}
    <Collapse
      title={
        <div className="flex items-center justify-between text-gray-700 font-medium text-sm">
          {info?.permitHolder?.companyName} <FaCaretDown className="mt-[1px]" />
        </div>
      }
    >
      <FormField label="Address" value={info?.permitHolder?.address} inputClass="text-sm py-1" />
      <FormField label="Address 2" value={info?.permitHolder?.address2} inputClass="text-sm py-1" />

      <div className="flex gap-2 mt-2">
        <FormField label="City" value={info?.permitHolder?.city} inputClass="text-sm py-1" />
        <FormField label="State" value={info?.permitHolder?.state} inputClass="text-sm py-1" />
        <FormField label="Zip" value={info?.permitHolder?.zip} inputClass="text-sm py-1" />
      </div>

      <div className="flex gap-2 mt-2">
        <FormSelect label="Permit Type" value={info?.permitHolder?.permitType} selectClass="text-sm py-1" />
        <FormField label="Permit Number" value={info?.permitHolder?.permitNumber} inputClass="text-sm py-1" />
      </div>

      <div className="flex gap-2 mt-2">
        <FormField label="Net Due Permit #" value={info?.permitHolder?.dueNetNumber} inputClass="text-sm py-1" />
        <FormField label="Account #" value={info?.permitHolder?.accountNumber} inputClass="text-sm py-1" />
      </div>

      <FormSelect label="BMEU" value={info?.permitHolder?.bmeu} selectClass="text-sm py-1 mt-2" />
    </Collapse>

    {/* Mail Owner */}
    <Collapse
      title={
        <div className="flex items-center justify-between text-gray-700 font-medium text-sm">
          {info?.mailOwner?.companyName} <FaCaretDown className="mt-[1px]" />
        </div>
      }
    >
      <FormField label="Address" value={info?.mailOwner?.address} inputClass="text-sm py-1" />
      <FormField label="Address 2" value={info?.mailOwner?.address2} inputClass="text-sm py-1" />

      <div className="flex gap-2 mt-2">
        <FormField label="City" value={info?.mailOwner?.city} inputClass="text-sm py-1" />
        <FormField label="State" value={info?.mailOwner?.state} inputClass="text-sm py-1" />
        <FormField label="Zip" value={info?.mailOwner?.zip} inputClass="text-sm py-1" />
      </div>

      <div className="flex gap-2 mt-2">
        <FormField label="CRID" value={info?.mailOwner?.crid} inputClass="text-sm py-1" />
        <FormField label="MID" value={info?.mailOwner?.mid} inputClass="text-sm py-1" />
      </div>

      <div className="flex gap-2 mt-2">
        <FormField label="Nonprofit Authorization #" value={info?.mailOwner?.nonprofitnumber} inputClass="text-sm py-1" />
        <FormField label="Mail Anywhere Account #" value={info?.mailOwner?.anywhere} inputClass="text-sm py-1" />
      </div>
    </Collapse>

    {/* Mail Provider */}
    <Collapse
      title={
        <div className="flex items-center justify-between text-gray-700 font-medium text-sm">
          {info?.mailProvider?.providerName} <FaCaretDown className="mt-[1px]" />
        </div>
      }
    >
      <FormField label="Address" value={info?.mailProvider?.address} inputClass="text-sm py-1" />
      <FormField label="Address 2" value={info?.mailProvider?.address2} inputClass="text-sm py-1" />

      <div className="flex gap-2 mt-2">
        <FormField label="City" value={info?.mailProvider?.city} inputClass="text-sm py-1" />
        <FormField label="State" value={info?.mailProvider?.state} inputClass="text-sm py-1" />
        <FormField label="Zip" value={info?.mailProvider?.zip} inputClass="text-sm py-1" />
      </div>

      <div className="flex gap-2 mt-2">
        <FormField label="CRID" value={info?.mailProvider?.crid} inputClass="text-sm py-1" />
        <FormField label="MID" value={info?.mailProvider?.mid} inputClass="text-sm py-1" />
      </div>

      <FormField label="Representative Name" value={info?.mailProvider?.repname} inputClass="text-sm py-1 mt-2" />

      <div className="flex gap-2 mt-2">
        <FormField label="Phone" value={info?.mailProvider?.repphone} inputClass="text-sm py-1" />
        <FormField label="Email" value={info?.mailProvider?.repemail} inputClass="text-sm py-1" />
      </div>

      <div className="flex gap-4 mt-3">
        <CheckboxField label="eInduction" checked={info?.mailProvider?.einduction} className="text-sm" />
        <CheckboxField label="Seamless Acceptance" checked={info?.mailProvider?.seamless} className="text-sm" />
      </div>
    </Collapse>
  </div>
</div>

          {/* <div className="mb-8 p-6 border border-gray-200 rounded-lg bg-white shadow-sm">
            <h2 className={sectionTitle}>Mailer Information</h2>

            <div className="grid lg:grid-cols-3 gap-6">
              <Collapse
                title={
                  <div className="flex justify-between items-center font-medium text-gray-700">
                    {info?.permitHolder?.companyName}
                    <FaCaretDown />
                  </div>
                }
              >
                <FormField label="Address" value={info?.permitHolder?.address} />
                <FormField label="Address 2" value={info?.permitHolder?.address2} />
                <div className="flex gap-3">
                  <FormField label="City" value={info?.permitHolder?.city} />
                  <FormField label="State" value={info?.permitHolder?.state} />
                  <FormField label="Zip" value={info?.permitHolder?.zip} />
                </div>
                <FormSelect label="Permit Type" value={info?.permitHolder?.permitType} />
                <div className="flex gap-3">
                  <FormField label="Permit Number" value={info?.permitHolder?.permitNumber} />
                  <FormField label="Net Due Permit #" value={info?.permitHolder?.dueNetNumber} />
                </div>
                <FormField label="Account #" value={info?.permitHolder?.accountNumber} />
                <FormSelect label="BMEU" value={info?.permitHolder?.bmeu} />
              </Collapse>

              <Collapse
                title={
                  <div className="flex justify-between items-center font-medium text-gray-700">
                    {info?.mailOwner?.companyName}
                    <FaCaretDown />
                  </div>
                }
              >
                <FormField label="Address" value={info?.mailOwner?.address} />
                <div className="flex gap-3">
                  <FormField label="City" value={info?.mailOwner?.city} />
                  <FormField label="State" value={info?.mailOwner?.state} />
                  <FormField label="Zip" value={info?.mailOwner?.zip} />
                </div>
                <FormField label="CRID" value={info?.mailOwner?.crid} />
                <FormField label="MID" value={info?.mailOwner?.mid} />
                <FormField label="Nonprofit #" value={info?.mailOwner?.nonprofitnumber} />
                <FormField label="Mail Anywhere #" value={info?.mailOwner?.anywhere} />
              </Collapse>

              <Collapse
                title={
                  <div className="flex justify-between items-center font-medium text-gray-700">
                    {info?.mailProvider?.providerName}
                    <FaCaretDown />
                  </div>
                }
              >
                <FormField label="Address" value={info?.mailProvider?.address} />
                <div className="flex gap-3">
                  <FormField label="City" value={info?.mailProvider?.city} />
                  <FormField label="State" value={info?.mailProvider?.state} />
                  <FormField label="Zip" value={info?.mailProvider?.zip} />
                </div>
                <FormField label="CRID" value={info?.mailProvider?.crid} />
                <FormField label="MID" value={info?.mailProvider?.mid} />
                <FormField label="Representative" value={info?.mailProvider?.repname} />
                <div className="flex gap-3">
                  <FormField label="Phone" value={info?.mailProvider?.repphone} />
                  <FormField label="Email" value={info?.mailProvider?.repemail} />
                </div>
                <div className="flex gap-6 mt-2">
                  <CheckboxField label="eInduction" checked={info?.mailProvider?.einduction} />
                  <CheckboxField label="Seamless Acceptance" checked={info?.mailProvider?.seamless} />
                </div>
              </Collapse>
            </div>
          </div> */}

          {/* MAIL DETAILS */}
          <div className="mb-8 p-6 border border-gray-200 rounded-lg bg-white shadow-sm">
            <h2 className={sectionTitle}>Mailing Details</h2>
            <div className="grid lg:grid-cols-3 gap-6">
              <FormField label="Product" value={info?.product?.name} />
              <FormField label="Mail Class" value={info?.mailClass} />
              <FormField label="Mail Date" value={info?.mailDate} />
              <FormField label="Post Office Entry" value={info?.postOfficeEntry} />
              <FormField label="USPS Job ID" value={info?.uspsJobId} />
              <div className="flex gap-6 flex-wrap">
                <CheckboxField label="Machineable" checked={info?.machinable} />
                <CheckboxField label="Drop Shipping" checked={info?.dropship === "true"} />
                <CheckboxField label="Growth Incentive" checked={info?.growthIncentive} />
                <CheckboxField label="Ballot Mail" checked={info?.ballotbox} />
                <CheckboxField label="Political Mail" checked={info?.political} />
              </div>
            </div>
          </div>

          {/* SUMMARY */}
          <div className="mb-8 p-6 border border-gray-200 rounded-lg bg-white shadow-sm">
            <h2 className={sectionTitle}>Summary</h2>
            <div className="grid lg:grid-cols-2 gap-6">
              <FormField label="Total Weight" value="" />
              <FormField label="Postage Amount" value="" />
            </div>
            <div className="mt-6">
              <label className={labelClass}>Additional Notes</label>
              <textarea
                className="w-full border border-gray-300 rounded-md p-3 text-sm"
                rows="4"
              />
            </div>
          </div>
        </TabPanel>

        {/* FILES TAB */}
        <TabPanel>
          <div
            className="flex items-center gap-3 p-4 border rounded-md bg-white hover:bg-gray-50 cursor-pointer w-fit"
            onClick={(e) =>
              handleDownload(e, user?.company.name, info.jobId, info.jobNum)
            }
          >
            <FaFileZipper size={22} className="text-blue-600" />
            <span className="text-sm font-medium text-gray-700">
              {info?.jobId}_{info?.jobNum}.zip
            </span>
          </div>
        </TabPanel>
      </Tabs>
    </div>
  );
};

export default JobsPanel;